<template>
  <div>
    <queryFrame @handlePage='handlePage' @handlePageSize='handlePageSize' :disablePage='true'
      :count="count" :current="page.currentPage">
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>数据直连名称:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable
              v-model.trim='query.taskName'></lk-input>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btns">
          <lk-button type='primary' @click="checkAndUpload" :disabled='!(taskIds.length && checkAndUploadStatus)'
            :loading='checkAndUploadLoading'>数据核验与上传</lk-button>
        </div>
        <lk-table border :columns='columns' :data='tableData' @on-selection-change='handleSeleted'>
        </lk-table>
      </div>
    </queryFrame>
    <DTPModal v-model="errModal" type='alert' :content='errContent' confirmText='上传'
      cancelText='不上传' @confirm='forceUpload' :confirmLoading='forceLoading'></DTPModal>
  </div>
</template>
<script>
import mapState from '../../mixins/mapState';
import queryMixins from '../../mixins/queryMixins';
import dataDirect from '../../services/dataDirect';
import utils from '../../libs/utils';
import queryFrame from '../../components/frame/QueryFrame.vue';
import DTPModal from '../../components/DTPModal.vue';

export default {
  name: 'dataCheckList',
  components: { queryFrame, DTPModal },
  mixins: [mapState, queryMixins],
  data() {
    return {
      checkAndUploadStatus: false,
      errModal: false,
      errContent: '',
      checkAndUploadLoading: false,
      forceLoading: false,
      singleLoading: false,
      taskIds: [],
      count: 0,
      checkResultList: {
        1: '正常',
        2: '异常',
        3: '必填数据缺失',
        4: '未执行',
      },
      statusList: {
        1: '文件生成中',
        2: '文件生成成功',
        3: '文件生成失败',
        4: '文件校验中',
        5: '文件校验成功',
        6: '文件校验失败',
        7: '文件上传中',
        8: '文件上传成功',
        9: '文件上传失败',
      },
      query: {},
      tableData: [],
      columns: [
        {
          title: '',
          type: 'selection',
          width: 60,
        },
        {
          title: '数据直连名称',
          key: 'name',
          minWidth: 116,
        },
        {
          title: '备注',
          minWidth: 116,
          key: 'remark',
        },
        {
          title: '生成时间',
          minWidth: 116,
          key: 'createTime',
        },
        {
          title: '校验结果',
          minWidth: 116,
          key: 'checkResult',
          render: (h, params) => h('span', {
            class: {
              error: params.row.checkResult === 2,
            },
          }, this.checkResultList[params.row.checkResult]),
        },
        {
          title: '上传状态',
          minWidth: 116,
          key: 'uploadStatus',
          render: (h, params) => h('span', {
            class: {
              error: params.row.status === 9,
            },
          }, this.statusList[params.row.status]),
        },
        {
          title: '操作',
          minWidth: 116,
          render: (h, params) => h('div',
            [
              h('lk-button', {
                props: {
                  type: 'text',
                  size: 'small',
                  disabled: !this.handlePermission('dataCheckInfo'),
                },
                on: {
                  click: () => {
                    this.$router.push({ name: 'dataCheckInfo', params: { id: params.row.id, name: params.row.name, ruleId: params.row.ruleId } });
                  },
                },
              }, '查看'),
              (params.row.status === 9 || (params.row.checkResult === 2 && (params.row.status === 2 || params.row.status === 5))) ? h('lk-button', {
                props: {
                  size: 'small',
                  type: 'text',
                  disabled: !this.handlePermission('dataCheckUpload'),
                },
                on: {
                  click: () => {
                    this.uploadSingle(params.row.id);
                  },
                },
              }, '手动上传') : null,
            ]),
        },
      ],
    };
  },
  methods: {
    forceUpload() {
      this.forceLoading = true;
      dataDirect.forceUploadData({ taskIds: this.taskIds }).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('上传成功');
          this.getData();
        } else {
          this.$Message.error(res.data.error);
        }
        this.forceLoading = false;
      }).catch((err) => {
        utils.handleError(err);
        this.forceLoading = false;
      });
    },
    checkAndUpload() {
      this.checkAndUploadLoading = true;
      dataDirect.uploadDataAndCheck({ taskIds: this.taskIds }).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('处理成功');
          this.getData();
        } else if (res.data.status === 100001) {
          this.errContent = res.data.error;
          this.errModal = true;
        } else {
          this.$Message.error(res.data.error);
        }
        this.checkAndUploadLoading = false;
      }).catch((err) => {
        utils.handleError(err);
        this.checkAndUploadLoading = false;
      });
    },
    uploadSingle(id) {
      if (this.singleLoading) {
        return;
      }
      this.singleLoading = true;
      dataDirect.uploadData({ taskId: id }).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('上传成功');
          this.getData();
        } else {
          this.$Message.error(res.data.error);
        }
        this.singleLoading = false;
      }).catch((err) => {
        utils.handleError(err);
        this.singleLoading = false;
      });
    },
    handleSeleted(seletions) {
      this.taskIds = [];
      seletions.forEach((item) => {
        this.taskIds.push(item.id);
      });
    },
    getData() {
      dataDirect.getTaskList(this.params).then((res) => {
        if (res.data.status === 200) {
          const { data } = res.data;
          this.tableData = [];
          this.taskIds = [];
          this.count = data.count;
          data.forEach((item) => {
            item.createTime = utils.exchangeTime(item.createTime);
            item.statusName = this.statusList[item.status];
            item.checkResultName = this.checkResultList[item.checkResult];
            this.tableData.push(item);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clear() {
      this.query = {};
    },
  },
  mounted() {
    this.handleSearch(true);
    this.checkAndUploadStatus = this.handlePermission('dataCheckAndUpload');
  },
};
</script>
<style lang="less" scoped>
.btns{
  margin-bottom: 16px;
  >*{
    margin-right: 8px
  }
}
</style>
